




import React, { useEffect, useRef, useState } from "react";
import { Outlet, Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  Bars3Icon,
  HomeIcon,
  ArrowLeftOnRectangleIcon,
  NewspaperIcon,
  UsersIcon,
  UserCircleIcon,
  PhotoIcon,
  SquaresPlusIcon,
  ShieldCheckIcon,
  CubeIcon,
  VideoCameraIcon,
  BellIcon,
  ChatBubbleLeftRightIcon,
  DocumentPlusIcon,
  CalendarDateRangeIcon,
  ClipboardDocumentIcon,
  KeyIcon,
  ChevronDownIcon,
  Cog6ToothIcon,
  XMarkIcon,
  Squares2X2Icon,
  BuildingOffice2Icon,
  CurrencyDollarIcon,
  ClockIcon,
} from "@heroicons/react/24/outline";
import { ChevronDoubleLeftIcon, UserIcon } from "@heroicons/react/16/solid";
import { setUsers } from "../features/admin/UserSlice";
import UserModalComponent from "../components/admin/UserModal";

const getUserPermissions = () => {
  const permissions = localStorage.getItem("permissions");
  return permissions
    ? JSON.parse(permissions).map((p) => p.permissionSlug)
    : [];
};

const hasPermission = (requiredPermission) => {
  const currentUserId = localStorage.getItem("userId");
  if (currentUserId == 1) {
    return true;
  }
  const userPermissions = getUserPermissions();
  return userPermissions.includes(requiredPermission);
};

const AdminLayout = () => {
  const userId = localStorage.getItem("userId");
  const [isSidebarOpen, setIsSidebarOpen] = useState(
    window.innerWidth < 1024 ? false : true
  );
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [isUserModalOpen, setIsUserModalOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [isOption, setIsOption] = useState(false);
  const dropdownRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleCloseModal = () => {
    setIsUserModalOpen(false);
  };

  const handleSaveUser = (user) => {
    if (user.id) {
      dispatch(setUsers(user));
    } else {
      const newUser = { ...user, id: Date.now() };
      dispatch(setUsers(newUser));
    }
    handleCloseModal();
  };

  const handleMenuItemClick = () => {
    if (window.innerWidth < 1024) {
      setIsSidebarOpen(false);
    }

    setIsOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("access_token_bccu");
    localStorage.removeItem("permissions");
    localStorage.removeItem("full_name");
    localStorage.removeItem("type_user");
    localStorage.removeItem("userId");
    localStorage.removeItem("companyId");
    localStorage.removeItem("userPhone");
    localStorage.removeItem("userEmail");
    localStorage.setItem("cart", JSON.stringify([]));
    window.location.href = "/login";
  };

  return (
    <div className="flex h-screen">
      {isSidebarOpen && (
        <div
          className="fixed inset-0 z-10 bg-black bg-opacity-50 lg:hidden"
          onClick={() => setIsSidebarOpen(false)}
        >
          x
        </div>
      )}

      {/* Sidebar */}
      <aside
        className={`fixed 
          ${
            isSidebarOpen
              ? "translate-x-0 lg:static lg:translate-x-0"
              : "-translate-x-full"
          }
          transition-transform duration-300
          w-64 lg:w-64 h-screen overflow-y-auto
          shadow-lg lg:shadow-none z-20 bg-base-100 lg:bg-transparent`}
      >
        <button
          className="lg:hidden absolute top-4 right-4"
          onClick={() => setIsSidebarOpen(false)}
        >
          <XMarkIcon className="h-6 w-6 text-primary" />
        </button>

        <ul className="menu menu-vertical p-4 space-y-2 mt-7 max-sm:mb-40 lg:mt-0">
          <li>
            <Link to="/admin/dashboard" onClick={handleMenuItemClick}>
              <Squares2X2Icon className="h-5 w-5 text-red-600" />
              <span className="lg:block">Tổng quan</span>
            </Link>
          </li>
          {hasPermission("COMPANY_SHOW") && (
            <li>
              <Link to="/admin/partner" onClick={handleMenuItemClick}>
                <BuildingOffice2Icon className="h-5 w-5 text-blue-600" />
                <span className="lg:block">Hội viên</span>
              </Link>
            </li>
          )}
          {hasPermission("USER_SHOW") && (
            <li>
              <Link to="/admin/users" onClick={handleMenuItemClick}>
                <UsersIcon className="h-5 w-5 text-yellow-600" />
                <span className="lg:block">Người dùng</span>
              </Link>
            </li>
          )}
          {hasPermission("MEMBERSHIP_FEE_SHOWS") && (
            <li>
              <Link to="/admin/membershipfees" onClick={handleMenuItemClick}>
                <CurrencyDollarIcon className="h-5 w-5 text-green-600" />
                <span className="lg:block">Hội phí</span>
              </Link>
            </li>
          )}
          {hasPermission("SPONSOR_SHOW") && (
            <li>
              <Link to="/admin/sponsors" onClick={handleMenuItemClick}>
                <BuildingOffice2Icon className="h-5 w-5 text-orange-600" />
                <span className="lg:block">Nhà tài trợ</span>
              </Link>
            </li>
          )}
          {hasPermission("POST_SHOW") && (
            <li>
              <Link to="/admin/notification" onClick={handleMenuItemClick}>
                <BellIcon className="h-5 w-5 text-red-600" />
                <span className="lg:block">Thông báo</span>
              </Link>
            </li>
          )}
          {hasPermission("REGISTER_SHOW") && (
            <li>
              <Link to="/admin/registration" onClick={handleMenuItemClick}>
                <DocumentPlusIcon className="h-5 w-5 text-blue-600" />
                <span className="lg:block">Đăng ký hoạt động</span>
              </Link>
            </li>
          )}
          {hasPermission("POST_SHOW") && (
            <li>
              <Link to="/admin/posts" onClick={handleMenuItemClick}>
                <NewspaperIcon className="h-5 w-5 text-green-500" />
                <span className="lg:block">Bài viết</span>
              </Link>
            </li>
          )}
          {hasPermission("COMMENT_SHOW") && (
            <li>
              <Link to="/admin/feedback" onClick={handleMenuItemClick}>
                <ChatBubbleLeftRightIcon className="h-5 w-5 text-yellow-500" />
                <span className="lg:block">Bình luận</span>
              </Link>
            </li>
          )}
          {hasPermission("PRODUCT_SHOW") && (
            <li>
              <Link to="/admin/product" onClick={handleMenuItemClick}>
                <CubeIcon className="h-5 w-5 text-red-600" />
                <span className="lg:block">Sản phẩm</span>
              </Link>
            </li>
          )}
          {hasPermission("BILL_SHOW") && (
            <li>
              <Link to="/admin/order" onClick={handleMenuItemClick}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="yellow"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-receipt w-5 h-5 stroke-blue-600"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2m4 -14h6m-6 4h6m-2 4h2" />
                </svg>
                <span className="lg:block">Giá trị giao dịch</span>
              </Link>
            </li>
          )}
          {hasPermission("CONTACT_SHOW") && (
            <li>
              <Link to="/admin/contact" onClick={handleMenuItemClick}>
                <ClipboardDocumentIcon className="h-5 w-5 text-green-600" />
                <span className="lg:block">Liên hệ</span>
              </Link>
            </li>
          )}
          {userId != 1 && hasPermission("BILL_SHOW") && (
            <li>
              <Link to="/admin/order-history" onClick={handleMenuItemClick}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-shopping-cart-dollar w-5 h-5 stroke-yellow-600"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M4 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                  <path d="M13 17h-7v-14h-2" />
                  <path d="M6 5l14 1l-.575 4.022m-4.925 2.978h-8.5" />
                  <path d="M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5" />
                  <path d="M19 21v1m0 -8v1" />
                </svg>
                <span className="lg:block">Lịch sử giao dịch</span>
              </Link>
            </li>
          )}
          {hasPermission("COUPON_SHOW") && (
            <li>
              <Link to="/admin/coupon" onClick={handleMenuItemClick}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-rosette-discount w-5 h-5 stroke-red-600"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M9 15l6 -6" />
                  <circle cx="9.5" cy="9.5" r=".5" fill="currentColor" />
                  <circle cx="14.5" cy="14.5" r=".5" fill="currentColor" />
                  <path d="M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7a2.2 2.2 0 0 0 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1a2.2 2.2 0 0 0 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1" />
                </svg>
                <span className="lg:block">Mã thưởng</span>
              </Link>
            </li>
          )}
          <li>
            <Link to="/admin/media" onClick={handleMenuItemClick}>
              <PhotoIcon className="h-5 w-5 text-green-600" />
              <span className="lg:block">Hình ảnh</span>
            </Link>
          </li>
          <li>
            <Link to="/admin/videos" onClick={handleMenuItemClick}>
              <VideoCameraIcon className="h-5 w-5 text-red-600" />
              <span className="lg:block">Video</span>
            </Link>
          </li>
          {hasPermission("POINT_LOGS") && (
            <li>
              <Link to="/admin/point-log" onClick={handleMenuItemClick}>
                <CalendarDateRangeIcon className="h-5 w-5 text-yellow-600" />
                <span className="lg:block">Lịch sử cộng điểm</span>
              </Link>
            </li>
          )}
          <li>
            <div
              className="flex justify-between"
              onClick={() => setIsOption(!isOption)}
            >
              <div className="flex gap-2.5 items-center">
                <Cog6ToothIcon className="w-5 h-5 text-blue-600" />
                <span className="lg:block">Cài đặt</span>
              </div>
              <ChevronDownIcon className="h-5 w-5" />
            </div>
            {isOption && (
              <div className="flex flex-col items-start">
                {hasPermission("MEDIA_UPDATE") && (
                  <li>
                    <Link to="/admin/settings" onClick={handleMenuItemClick}>
                      <Cog6ToothIcon className="h-5 w-5 text-blue-600" />
                      <span className="lg:block">Cài đặt chung</span>
                    </Link>
                  </li>
                )}
                {hasPermission("ROLE_SHOW") && (
                  <li>
                    <Link to="/admin/roles" onClick={handleMenuItemClick}>
                      <UserCircleIcon className="h-5 w-5 text-green-600" />
                      <span className="lg:block">Chức vụ</span>
                    </Link>
                  </li>
                )}
                {hasPermission("CATEGORY_SHOW") && (
                  <li>
                    <Link to="/admin/category" onClick={handleMenuItemClick}>
                      <SquaresPlusIcon className="h-5 w-5 text-yellow-500" />
                      <span className="lg:block">Danh mục</span>
                    </Link>
                  </li>
                )}
                {hasPermission("PERMISSIONS_SHOW") && (
                  <li>
                    <Link
                      to="/admin/permission-show"
                      onClick={handleMenuItemClick}
                    >
                      <ShieldCheckIcon className="h-5 w-5 text-red-600" />
                      <span className="lg:block">Phân quyền danh mục</span>
                    </Link>
                  </li>
                )}
                {hasPermission("AUDIT_LOG_SHOW") && (
                  <li>
                    <Link
                      to="/admin/audit-logs"
                      onClick={handleMenuItemClick}
                    >
                      <ClockIcon className="h-5 w-5 text-blue-600" />
                      <span className="lg:block">Nhật ký hệ thống</span>
                    </Link>
                  </li>
                )}
                {hasPermission("CRITERIA_SHOW") && (
                  <li>
                    <Link to="/admin/criteria" onClick={handleMenuItemClick}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="icon icon-tabler icons-tabler-outline icon-tabler-pointer-up w-5 h-5 stroke-red-600"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M15.984 13.428l-1.206 -1.206l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l1.217 1.217" />
                        <path d="M19 22v-6" />
                        <path d="M22 19l-3 -3l-3 3" />
                      </svg>
                      <span className="lg:block">Tiêu chí</span>
                    </Link>
                  </li>
                )}
              </div>
            )}
          </li>
        </ul>
      </aside>

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden lg:relative ">
        {/* Navbar */}
        <nav className="bg-base-200 shadow-lg py-2 px-4 flex justify-end items-center z-50 ">
          <div className="flex space-x-1 items-center ">
            <button className="text-lg flex" onClick={() => setIsOpen(!isOpen)}>
              <span className="text-sm content-center">Xin chào</span>{" "}
              <span className="font-semibold ms-1">
                {localStorage.getItem("full_name")}
              </span>
              <UserIcon className="h-6 w-6 ms-1" />
              <ChevronDownIcon className=" h-6 w-3" />
            </button>

            <div className=" relative inline-block text-left" ref={dropdownRef}>
              {isOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-base-300 rounded-lg shadow-lg z-10">
                  <ul className="p-3 py-4 space-y-5">
                    {userId != 1 && (
                      <li>
                        <Link
                          onClick={() => {
                            setIsUserModalOpen(true);
                          }}
                          className="flex items-center gap-1"
                        >
                          <UserIcon className="h-5 w-5" />
                          <span className="lg:block">Thông tin cá nhân</span>
                        </Link>
                      </li>
                    )}
                    <li>
                      <Link
                        to="/admin/change-password"
                        onClick={handleMenuItemClick}
                        className="flex items-center gap-1"
                      >
                        <KeyIcon className="h-5 w-5" />
                        <span className="lg:block">Đổi mật khẩu</span>
                      </Link>
                    </li>
                    <li>
                      <button
                        onClick={() => setShowLogoutConfirm(true)}
                        className="flex items-center gap-1"
                      >
                        <ArrowLeftOnRectangleIcon className="h-5 w-5 text-green-600" />
                        <span className="lg:block">Đăng xuất</span>
                      </button>
                    </li>
                  </ul>
                </div>
              )}
            </div>

            <button
              className="lg:absolute lg:left-1 btn btn-info px-2 py-0 min-h-8 h-8"
              onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            >
              {isSidebarOpen ? (
                <ChevronDoubleLeftIcon className="h-6 w-6 text-white" />
              ) : (
                <Bars3Icon className="h-6 w-6 text-white" />
              )}
            </button>

            <button
              className="lg:absolute lg:left-14 btn btn-info px-2 min-h-8 h-8"
              onClick={() => {
                navigate("/");
                window.location.reload();
              }}
            >
              <HomeIcon className="h-6 w-6 text-white" />
            </button>
          </div>
        </nav>

        {/* Main Page Content */}
        <main className="p-4 overflow-auto flex-1">
          <Outlet />
        </main>
      </div>

      {/* Xác nhận đăng xuất Modal */}
      {showLogoutConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 shadow-xl max-w-md w-full">
            <h3 className="text-lg font-medium mb-4">Xác nhận đăng xuất</h3>
            <p>Bạn có chắc chắn muốn đăng xuất khỏi hệ thống?</p>
            <div className="mt-6 flex justify-end gap-3">
              <button
                onClick={() => setShowLogoutConfirm(false)}
                className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50"
              >
                Hủy
              </button>
              <button
                onClick={handleLogout}
                className="px-4 py-2 bg-primary text-white rounded-md hover:bg-primary-focus"
              >
                Đồng ý
              </button>
            </div>
          </div>
        </div>
      )}

      {isUserModalOpen && (
        <UserModalComponent
          userIdProp={userId}
          onClose={handleCloseModal}
          onSave={handleSaveUser}
        />
      )}
    </div>
  );
};

export default AdminLayout;


